import subprogramListStore from '@modules/subprogram/subprogram-list-store';
import subprogramViewStore from '@modules/subprogram/subprogram-view-store';
import subprogramImporterStore from '@modules/subprogram/subprogram-importer-store';
import subprogramFormStore from '@modules/subprogram/subprogram-form-store';
import subprogramDestroyStore from '@modules/subprogram/subprogram-destroy-store';
import subprogramNbaStore from '@modules/subprogram/nba/subprogram-nba-store';
import subprogramNbaSchoolTeamStore from '@modules/subprogram/nba/subprogram-nba-school-team-page-store';

export default {
  namespaced: true,

  modules: {
    nba: subprogramNbaStore,
    nbaTeam: subprogramNbaSchoolTeamStore,
    destroy: subprogramDestroyStore,
    form: subprogramFormStore,
    list: subprogramListStore,
    view: subprogramViewStore,
    importer: subprogramImporterStore,
  },
};
